import { api } from 'shared';
import { z } from 'zod';

export const DeliveryArticleTagsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
        }),
    ),
});
export const fetchDeliveryArticleTags = async () => (
    api.get<z.infer<typeof DeliveryArticleTagsResponseSchema>>(
        '/delivery-article-tags',
        {},
        DeliveryArticleTagsResponseSchema,
    )
);
